<template>
  <div class="kpt-detail-content" style="padding: 12px; overflow-y: hidden">
    <div class="kpt-detail-content-actions">
      <div class="buttons">
        <b-button type="is-primary is-outlined" icon-left="user" size="is-small" v-if="!addingUserVisible" :disabled="isAddingUser" @click="showAddUser">Add New User</b-button>
        <b-button type="is-primary is-outlined" icon-left="save" size="is-small" v-if="addingUserVisible" :loading="isAddingUser" :disabled="isAddingUser || !canSubmitAdd" @click="saveNewUser">Save User</b-button>
        <b-button type="is-primary is-outlined" size="is-small" v-if="addingUserVisible" :disabled="isAddingUser" @click="hideAddUser">Cancel</b-button>
      </div>
    </div>
    <div v-if="addingUserVisible">
      <div class="columns">
        <div class="column">
          <b-field label="First Name" required>
            <b-input v-model="newUser.firstName" maxlength="255" :has-counter="false" spellcheck="false" />
          </b-field>
          <b-field label="Last Name">
            <b-input v-model="newUser.lastName" maxlength="255" :has-counter="false" spellcheck="false" />
          </b-field>
          <div class="is-flex" style="margin-bottom: 12px;">
            <div style="width: 50%; padding-right: 8px;">
              <b-field label="Email" required>
                <b-input type="email" v-model="newUser.email" maxlength="255" :has-counter="false" />
              </b-field>
            </div>
            <div style="width: 50%">
              <b-field label="Login Type" required>
                <b-select expanded v-model="newUser.loginType">
                  <option value="ThirdParty">Third Party (Google, Microsoft, Apple)</option>
                  <option value="Local">Local (Email/Password)</option>
                </b-select>
              </b-field>
            </div>
          </div>
          <b-field label="Account" required>
            <b-select expanded v-model="newUser.accountId">
              <option :value="account.id" v-for="account in accounts" :key="account.id">{{account.name}}</option>
            </b-select>
          </b-field>
          <b-field label="Role" required>
            <b-select expanded v-model="newUser.roleId">
              <option :value="role.id" v-for="role in roles" :key="role.id">{{role.name}}</option>
            </b-select>
          </b-field>
        </div>
        <div class="column">
          <b-field label="Description">
            <b-input type="textarea" rows="14" v-model="newUser.description" maxlength="1000"  />
          </b-field>
        </div>
        <div class="column"></div>
      </div>
    </div>
    <hr v-if="addingUserVisible">
    <b-table
      :data="users"
      ref="usersTable"
      paginated
      :per-page="100"
      :current-page.sync="currentPage"
      default-sort-direction="asc"
      default-sort="firstName"
      :striped="true"
      :row-class="(row, index) => row && 'has-cursor-pointer'"
      hoverable
      :selected.sync="selectedUser"
      :loading="isLoading"
      class="has-horizontal-scroll">
      <b-table-column field="firstName" label="Name" v-slot="props" sortable searchable :custom-search="searchUser">
        <a>{{props.row.firstName}} {{props.row.lastName}}</a>
      </b-table-column>
      <b-table-column field="email" label="Email" v-slot="props" sortable searchable cell-class="is-220 truncate">
        {{props.row.email}}
      </b-table-column>
      <b-table-column field="roleId" label="Role" v-slot="props" sortable cell-class="is-150 truncate">
        {{props.row.roleName}}
      </b-table-column>
      <b-table-column field="accountName" label="Account" v-slot="props" sortable searchable cell-class="is-250 truncate">
        {{props.row.accountName}}
      </b-table-column>
      <b-table-column field="enabled" label="Enabled" v-slot="props" width="80" sortable>
        <b-switch v-model="props.row.enabled" @input="disableUser(props.row.id, !props.row.enabled)"></b-switch>
      </b-table-column>

      <template slot="empty">
        <section class="section">
          <div class="content has-text-grey has-text-centered">
            <p>No users found.</p>
          </div>
        </section>
      </template>
    </b-table>

    <b-sidebar
      class="sidebar-inner"
      :fullheight="true"
      :fullwidth="false"
      :overlay="false"
      :right="true"
      :open="selectedUser != null"
      @close="selectedUser = null"
      position="absolute"
      :can-cancel="['escape']"
    >
      <user-detail-component @reselect="selectUser" @close="selectedUser = null" :selectedUser="selectedUser"></user-detail-component>
    </b-sidebar>
  </div>
</template>
<script>
import { orderBy } from 'lodash';
import UserDetailComponent from './components/UserDetailComponent.vue';

export default {
  data() {
    return {
      currentPage: 1,
      addingUserVisible: false,
      isAddingUser: false,
      newUser: {
        firstName: '',
        lastName: '',
        roleId: '',
        accountId: '',
        description: '',
        email: '',
        loginType: 'ThirdParty'
      },
      selectedUser: null
    }
  },
  components: {
    UserDetailComponent
  },
  computed: {
    users() {
      return this.$store.state.admin.users.users;
    },
    roles() {
      return orderBy(this.$store.state.admin.roles.roles, ['name'], ['asc']);
    },
    accounts() {
      return orderBy(this.$store.state.accounts.accounts, ['name'], ['asc']);
    },
    isLoading() {
      return this.$store.state.admin.users.usersLoading;
    },
    userUpdating() {
      return this.$store.state.admin.users.userUpdating;
    },
    canSubmitAdd() {
      if (!!this.newUser.firstName && !!this.newUser.firstName.trim() && !!this.newUser.email && !!this.newUser.email.trim() && !!this.newUser.roleId && !!this.newUser.accountId) return true;
      return false;
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    async disableUser(userId, enabledState) {
      const userToDisable = JSON.parse(JSON.stringify(this.users.find(u => u.id == userId)));
      // userToDisable.enabled = enabledState;
      await this.$store.dispatch('updateUser', userToDisable);
      // KyAnalytics client plugin, event tracker
      this.$kya.event('accounts', 'disableUser', 'Disable user', { userId });
    },
    showAddUser() {
      this.addingUserVisible = true;
    },
    hideAddUser() {
      this.addingUserVisible = false;
      this.newUser = {
        firstName: '',
        lastName: '',
        roleId: null,
        accountId: null,
        description: ''
      }
    },
    async saveNewUser() {
      this.isAddingUser = true;
      const result = await this.$store.dispatch('addUser', this.newUser);
      this.isAddingUser = false;
      if (result) {
        this.$buefy.toast.open({
          duration: 3000,
          message: `User [${this.newUser.firstName} ${this.newUser.lastName}] added successfully!`,
          position: 'is-bottom-right',
          type: 'is-success'
        })
        this.hideAddUser();
      } else {
        this.$buefy.toast.open({
          duration: 3000,
          message: `User [${this.newUser.firstName} ${this.newUser.lastName}] failed to add.`,
          position: 'is-bottom-right',
          type: 'is-danger'
        })
      }
      // KyAnalytics client plugin, event tracker
      this.$kya.event('accounts', 'addUser', 'Save new user', { payload: this.newUser });
    },
    selectDifferentAccount() {
      this.userToUpdate.roleId = null;
    },
    searchUser(user, term) {
      const termLower = term?.toLowerCase();
      return user.firstName?.toLowerCase().includes(termLower) || user.lastName?.toLowerCase().includes(termLower);
    },
    selectUser(payload) {
      this.selectedUser = payload;
    }
  }
}
</script>
